<div>
  <a
    tabindex="0"
    [routerLink]="['/news']"
  > {{ 'dpNews.goToNews' | cxTranslate }}
  </a>
</div>
<div
  class="row justify-content-center"
  *ngIf="news$ | async as news"
>
  <div class="newsDetail col-9">
    <h2> {{ news.newsTitle }}</h2>
    <div>
      <p>{{ getFormattedDate(news.creationDate) }}</p>
    </div>
    <div
      class="newsDetailMedia"
      *ngIf="news.image"
    >
      <cx-media
        [container]="news.image"
        loading="lazy"
      ></cx-media>
    </div>

  </div>

</div>
